import axios from "axios";
import { HOST } from "config/config";

export function getDurations() {
  return (dispatch, getState) => {
    if (!getState().durationsReducer.pending) {
      return dispatch({
        type: "GET_DURATIONS_PENDING",
        payload: axios
          .get(`${HOST}/api/filters/durations`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_DURATION_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "SHOW_MESSAGE",
              payload: {
                type: "error",
                titleKey: "error",
                message: error.message
              }
            })
          )
      });
    }
  };
}
